export default __webpack_public_path__ + "static/107983-33117904a3a938b1a7e5fd0bef904603.jpg";